import './media-banner-video.css';

import { createEffect, onCleanup } from 'solid-js';
import {
  customShadowlessElement,
  type CorrectComponentType,
  correctElementType,
} from '@brytdesigns/web-component-core/utils';

type Props = Record<string, never>;

const PLAYING_ATTR = 'data-playing';

const Component: CorrectComponentType<Props> = (_props, { element }) => {
  createEffect(() => {
    const video = element.querySelector<HTMLVideoElement>('video');

    const playButtons = element.querySelectorAll<HTMLElement>('[data-play-button]');
    if (!video || !playButtons.length) return;

    video.controls = false;

    const controller = new AbortController();
    const { signal } = controller;

    const play = () => {
      element.setAttribute(PLAYING_ATTR, 'true');
      video.controls = true;
      void video.play();
    };

    playButtons.forEach((button) => button.addEventListener('click', play, { signal }));

    onCleanup(() => controller.abort());
  });
};

customShadowlessElement('media-banner-video', {}, correctElementType(Component));
